<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useMessageCenterStore } from '@/store';
import ChatThread from './components/ChatThread.vue';
import { ChatInterface } from '@/types/MessageCenter';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';

const messageCenter = useMessageCenterStore();
const { screen, sortedChats } = storeToRefs(messageCenter);

const openNewChat = () => {
  screen.value = 'new-chat';
};

const getLastMessage = (chat: ChatInterface) => {
  let lastMessage = chat.last_message;
  if (!lastMessage) return '';
  const content = lastMessage?.content;

  if (!content && lastMessage.attachments && lastMessage.attachments.length > 0) {
    let lastAttachment: string = lastMessage.attachments?.[0].name || '';

    if (lastAttachment.startsWith('audio')) {
      return 'Audio Message';
    }
    return lastAttachment;
  }

  return content;
};
</script>

<template>
  <div class="fadeinleft">
    <AppButton
      v-if="can([PERMISSIONS.CHAT_STORE])"
      type="secondary"
      text="New Message"
      icon-left="add"
      full-width
      @click="openNewChat"
    ></AppButton>
    <ChatThread
      v-for="chat in sortedChats"
      :id="chat.id"
      :key="chat.id"
      :last-message="getLastMessage(chat)"
      :unread-count="chat.unread_count"
      :name="chat.name"
      :updated-at="chat.updated_at"
    />
  </div>
</template>
